// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Skillet$LiteracyplanetTupperware from "./Skillet.res.mjs";
import * as PilotDragPanel$LiteracyplanetTupperware from "../v3/PilotDragPanel.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "../v3/TupperwareLayoutSwitch.res.mjs";

function SkilfulDragPanelSticky$Skilful(props) {
  return React.createElement("div", {
              className: Skillet$LiteracyplanetTupperware.SkilfulDragPanelSticky.className
            }, props.children);
}

var Skilful = {
  make: SkilfulDragPanelSticky$Skilful
};

function SkilfulDragPanelSticky(props) {
  var children = props.children;
  if (TupperwareLayoutSwitch$LiteracyplanetTupperware.use() === "Pilot") {
    return React.createElement(PilotDragPanel$LiteracyplanetTupperware.make, {
                children: children
              });
  } else {
    return React.createElement(SkilfulDragPanelSticky$Skilful, {
                children: children
              });
  }
}

var make = SkilfulDragPanelSticky;

var $$default = SkilfulDragPanelSticky;

export {
  Skilful ,
  make ,
  $$default as default,
}
/* react Not a pure module */
